export const headerConfig = {
  headerTitle: 'Approved Applications',
  headerDescription: 'List of Approved Applications',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
